import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Alert,
    CircularProgress,
} from "@mui/material";
import ReportService from "../../../services/Report.service";

export default function DeleteReportDialog({ open, onClose, report, onDeleted }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleDelete = async () => {
        if (!report) return;
        setLoading(true);
        setError("");
        try {
            await ReportService.deleteRFTestReport(report.id);
            onDeleted();
            onClose();
        } catch {
            setError("Failed to delete the report. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Delete Report</DialogTitle>
            <DialogContent>
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}
                <Typography>
                    Are you sure you want to delete report{" "}
                    <strong>{report?.report_number}</strong>? This action cannot
                    be undone.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleDelete}
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={16} /> : null}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
